import { createContext, useContext } from 'react';

/** White-label branding applied to the panel chrome (M1). */
export interface BrandingValue {
  /** Product name shown in the wordmark/title. */
  productName: string;
  /** Tenant logo URL, or null to use the default gradient mark. */
  logoUrl: string | null;
  /** Height in px of the tenant logo image in the header. */
  logoHeightPx: number;
}

/** DocuSense baseline — used until (and if) a tenant configures branding. */
export const DEFAULT_BRANDING: BrandingValue = { productName: 'DocuSense', logoUrl: null, logoHeightPx: 32 };

/** Defaults to the DocuSense baseline so components work even outside a provider (e.g. login). */
export const BrandingContext = createContext<BrandingValue>(DEFAULT_BRANDING);

/** Reads the active branding; returns the DocuSense baseline when no provider is mounted. */
export function useBranding(): BrandingValue {
  return useContext(BrandingContext);
}
